import React from "react";
import { Flex, Text } from "@chakra-ui/react";

export function DemoSuccessContent({ isPrivateBrowser }: { isPrivateBrowser?: boolean }) {
  return (
    <Flex
      align="center"
      justify="center"
      flex={1}
      p={{ base: "smallest", md: "small" }}
      borderRadius="smaller"
      bg="new.yellow.150"
    >
      <Text textStyle={{ base: "caption1", md: "headline3" }} fontWeight={{ base: "semibold", md: "bold" }}>
        Thank you. We have received your request and will reach out shortly.
        {isPrivateBrowser && ` To book a time directly, please use a non-private browser.`}
      </Text>
    </Flex>
  );
}
